import { render, staticRenderFns } from "./AutomatorButton.vue?vue&type=template&id=63826445&scoped=true&"
import script from "./AutomatorButton.vue?vue&type=script&lang=js&"
export * from "./AutomatorButton.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorButton.vue?vue&type=style&index=0&id=63826445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63826445",
  null
  
)

export default component.exports